import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ planId = '', ...params }) => {
  return await dponetAPI.get(`/plans/${planId}`, { params })
}

export default { get }
